import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateChain, type UpdateChainBody } from "../api/chains";
import type { ChainSummary } from "../types/chain";

export function useUpdateChain() {
  const qc = useQueryClient();
  return useMutation<ChainSummary, Error, { id: string; body: UpdateChainBody }>({
    mutationFn: ({ id, body }) => updateChain(id, body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["chains"] });
    },
  });
}
